import React, { useState } from 'react';
import { Layout, Typography, Badge, Space, Avatar, Card, Button, List, Tag, Row, Col, Divider, Statistic } from 'antd';
import { 
  UserOutlined, 
  BellOutlined, 
  HomeOutlined,
  ShoppingOutlined,
  GiftOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
  RightOutlined,
  StarFilled,
  ClockCircleOutlined,
  CrownOutlined,
  ShopOutlined,
  CalendarOutlined,
  WalletOutlined,
  TeamOutlined
} from '@ant-design/icons';

const { Header, Content, Footer } = Layout;
const { Title, Text, Paragraph } = Typography;

/**
 * 会员移动应用容器组件
 */
const MobileCustomerApp: React.FC = () => {
  const [activeTab, setActiveTab] = useState('home');
  
  // 模拟未读通知数量
  const notificationCount = 3;
  
  // 模拟会员信息
  const memberInfo = {
    name: '李先生',
    phone: '139****7890',
    cardType: '铂金会员',
    balance: 2680,
    points: 4560,
    coupons: 6,
    avatarUrl: null
  };

  // 模拟最近订单
  const recentOrders = [
    {
      id: 'ORD20230501',
      title: '行政套房 - 2晚',
      store: '秋果酒店·望京店',
      date: '2023-05-01',
      amount: 1580,
      status: '已完成'
    },
    {
      id: 'ORD20230420',
      title: '商务双床房 - 1晚',
      store: '秋果酒店·国贸店',
      date: '2023-04-20',
      amount: 680,
      status: '已完成'
    }
  ];

  // 模拟可用优惠券
  const availableCoupons = [
    {
      id: 'CPN001',
      title: '周末入住立减100元',
      condition: '订单满1000元可用',
      validDate: '2023-06-30前有效',
      type: '满减券',
      used: false
    },
    {
      id: 'CPN002',
      title: '生日专享房费7折',
      condition: '生日当月可用，需提前3天预订',
      validDate: '2023-12-31前有效',
      type: '折扣券',
      used: false
    },
    {
      id: 'CPN003',
      title: '行政酒廊免费体验券',
      condition: '入住行政房可用',
      validDate: '2023-07-15前有效',
      type: '体验券',
      used: false
    }
  ];

  // 渲染底部导航
  const renderFooter = () => {
    return (
      <Footer style={{ padding: 0, backgroundColor: '#fff', borderTop: '1px solid #f0f0f0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-around', padding: '8px 0' }}>
          <div 
            onClick={() => setActiveTab('home')} 
            style={{ textAlign: 'center', color: activeTab === 'home' ? '#529C8A' : '#999' }}
          >
            <HomeOutlined style={{ fontSize: 20 }} />
            <div style={{ fontSize: 12 }}>首页</div>
          </div>
          <div 
            onClick={() => setActiveTab('orders')} 
            style={{ textAlign: 'center', color: activeTab === 'orders' ? '#529C8A' : '#999' }}
          >
            <ShoppingOutlined style={{ fontSize: 20 }} />
            <div style={{ fontSize: 12 }}>订单</div>
          </div>
          <div 
            onClick={() => setActiveTab('rewards')} 
            style={{ textAlign: 'center', color: activeTab === 'rewards' ? '#529C8A' : '#999' }}
          >
            <GiftOutlined style={{ fontSize: 20 }} />
            <div style={{ fontSize: 12 }}>礼遇</div>
          </div>
          <div 
            onClick={() => setActiveTab('profile')} 
            style={{ textAlign: 'center', color: activeTab === 'profile' ? '#529C8A' : '#999' }}
          >
            <UserOutlined style={{ fontSize: 20 }} />
            <div style={{ fontSize: 12 }}>我的</div>
          </div>
        </div>
      </Footer>
    );
  };

  // 渲染会员首页
  const renderHome = () => {
    return (
      <div style={{ padding: '0 16px 16px' }}>
        <Card 
          style={{ 
            marginTop: 16, 
            borderRadius: 8,
            background: 'linear-gradient(135deg, #4E6CA8 0%, #292E49 100%)',
            color: '#fff'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Avatar size={60} icon={<UserOutlined />} style={{ backgroundColor: '#fff', color: '#1890ff' }} />
            <div style={{ marginLeft: 16 }}>
              <div style={{ fontSize: 18, fontWeight: 'bold' }}>{memberInfo.name}</div>
              <div style={{ marginTop: 4 }}>
                <Tag color="gold">
                  <CrownOutlined /> {memberInfo.cardType}
                </Tag>
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>账户余额</div>
              <div style={{ fontSize: 18, fontWeight: 'bold' }}>{memberInfo.balance}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>积分</div>
              <div style={{ fontSize: 18, fontWeight: 'bold' }}>{memberInfo.points}</div>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>优惠券</div>
              <div style={{ fontSize: 18, fontWeight: 'bold' }}>{memberInfo.coupons}</div>
            </div>
          </div>
        </Card>

        <div style={{ marginTop: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={5} style={{ margin: 0 }}>我的专属管家</Title>
            <Button type="link" size="small" style={{ paddingRight: 0 }}>
              详情 <RightOutlined />
            </Button>
          </div>
          <Card style={{ marginTop: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Avatar size={50} icon={<UserOutlined />} style={{ backgroundColor: '#529C8A' }} />
              <div style={{ marginLeft: 12 }}>
                <div style={{ fontSize: 16, fontWeight: 'bold' }}>张经理</div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                  <Tag color="blue">资深客户管家</Tag>
                  <span style={{ marginLeft: 8 }}>服务2年</span>
                </div>
              </div>
            </div>
            <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
              <Button icon={<PhoneOutlined />} type="primary" ghost style={{ flex: 1 }}>
                联系管家
              </Button>
              <Button type="primary" style={{ flex: 1 }}>预订服务</Button>
            </div>
          </Card>
        </div>

        <div style={{ marginTop: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={5} style={{ margin: 0 }}>推荐酒店</Title>
            <Button type="link" size="small" style={{ paddingRight: 0 }}>
              查看全部 <RightOutlined />
            </Button>
          </div>
          <div style={{ marginTop: 8 }}>
            <Card 
              style={{ marginBottom: 12 }}
              cover={
                <div 
                  style={{ 
                    height: 150, 
                    backgroundImage: 'url(https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8
                  }}
                >
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '4px 12px',
                    background: 'linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))',
                    borderBottomLeftRadius: 8,
                    borderBottomRightRadius: 8,
                    color: '#fff'
                  }}>
                    <div style={{ fontWeight: 'bold' }}>秋果酒店·望京店</div>
                    <div style={{ fontSize: 12, display: 'flex', alignItems: 'center' }}>
                      <EnvironmentOutlined style={{ marginRight: 4 }} />
                      <span>北京市朝阳区望京南湖中园</span>
                    </div>
                  </div>
                </div>
              }
            >
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <Text style={{ marginLeft: 8, color: '#666', fontSize: 12 }}>4.9分 (238评价)</Text>
                    </div>
                  </div>
                  <div style={{ color: '#FF4D4F', fontWeight: 'bold' }}>¥680起</div>
                </div>
                <div style={{ marginTop: 8 }}>
                  <Tag color="green">会员专享价</Tag>
                  <Tag color="orange">双倍积分</Tag>
                  <Tag color="blue">免费停车</Tag>
                </div>
              </div>
            </Card>

            <Card 
              style={{ marginBottom: 12 }}
              cover={
                <div 
                  style={{ 
                    height: 150, 
                    backgroundImage: 'url(https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?q=80&w=2070)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8
                  }}
                >
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '4px 12px',
                    background: 'linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0))',
                    borderBottomLeftRadius: 8,
                    borderBottomRightRadius: 8,
                    color: '#fff'
                  }}>
                    <div style={{ fontWeight: 'bold' }}>秋果酒店·国贸店</div>
                    <div style={{ fontSize: 12, display: 'flex', alignItems: 'center' }}>
                      <EnvironmentOutlined style={{ marginRight: 4 }} />
                      <span>北京市朝阳区建国门外大街</span>
                    </div>
                  </div>
                </div>
              }
            >
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <StarFilled style={{ color: '#FFCE00' }} />
                      <Text style={{ marginLeft: 8, color: '#666', fontSize: 12 }}>4.8分 (312评价)</Text>
                    </div>
                  </div>
                  <div style={{ color: '#FF4D4F', fontWeight: 'bold' }}>¥780起</div>
                </div>
                <div style={{ marginTop: 8 }}>
                  <Tag color="green">会员专享价</Tag>
                  <Tag color="red">行政礼遇</Tag>
                  <Tag color="purple">SPA折扣</Tag>
                </div>
              </div>
            </Card>
          </div>
        </div>

        <div style={{ marginTop: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={5} style={{ margin: 0 }}>最近订单</Title>
            <Button type="link" size="small" style={{ paddingRight: 0 }}>
              更多 <RightOutlined />
            </Button>
          </div>
          <List
            itemLayout="horizontal"
            dataSource={recentOrders}
            renderItem={order => (
              <List.Item>
                <Card style={{ width: '100%', marginTop: 8 }}>
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Text strong>{order.title}</Text>
                      <Text type="danger">¥{order.amount}</Text>
                    </div>
                    <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between' }}>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12, color: '#666' }}>
                          <ShopOutlined style={{ marginRight: 4 }} />
                          {order.store}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12, color: '#666', marginTop: 4 }}>
                          <CalendarOutlined style={{ marginRight: 4 }} />
                          {order.date}
                        </div>
                      </div>
                      <div>
                        <Tag color={order.status === '已完成' ? 'green' : 'blue'}>
                          {order.status}
                        </Tag>
                      </div>
                    </div>
                    <div style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end' }}>
                      <Button size="small" type="primary">查看详情</Button>
                    </div>
                  </div>
                </Card>
              </List.Item>
            )}
          />
        </div>

        <div style={{ marginTop: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Title level={5} style={{ margin: 0 }}>优惠券</Title>
            <Button type="link" size="small" style={{ paddingRight: 0 }}>
              全部 <RightOutlined />
            </Button>
          </div>
          <List
            itemLayout="horizontal"
            dataSource={availableCoupons}
            renderItem={coupon => (
              <List.Item>
                <Card 
                  style={{ 
                    width: '100%', 
                    marginTop: 8,
                    background: 'linear-gradient(90deg, #FFEFBA 0%, #FFFFFF 100%)',
                    borderLeft: '4px solid #F5A623'
                  }}
                >
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Text strong>{coupon.title}</Text>
                      <Tag color="orange">{coupon.type}</Tag>
                    </div>
                    <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
                      <div>{coupon.condition}</div>
                      <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                        <ClockCircleOutlined style={{ marginRight: 4 }} />
                        {coupon.validDate}
                      </div>
                    </div>
                    <div style={{ marginTop: 12, display: 'flex', justifyContent: 'flex-end' }}>
                      <Button size="small" type="primary">立即使用</Button>
                    </div>
                  </div>
                </Card>
              </List.Item>
            )}
          />
        </div>
      </div>
    );
  };

  // 主要内容
  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return renderHome();
      case 'orders':
        return (
          <div style={{ padding: 16 }}>
            <Title level={4}>我的订单</Title>
            <div style={{ display: 'flex', justifyContent: 'space-around', margin: '16px 0', padding: '8px 0', background: '#f9f9f9', borderRadius: 8 }}>
              <div style={{ textAlign: 'center' }}>
                <Button type="text">全部</Button>
              </div>
              <div style={{ textAlign: 'center' }}>
                <Button type="text">待付款</Button>
              </div>
              <div style={{ textAlign: 'center' }}>
                <Button type="text">待入住</Button>
              </div>
              <div style={{ textAlign: 'center' }}>
                <Button type="text">已完成</Button>
              </div>
            </div>
            <List
              itemLayout="horizontal"
              dataSource={[
                ...recentOrders,
                {
                  id: 'ORD20230310',
                  title: '豪华大床房 - 3晚',
                  store: '秋果酒店·三里屯店',
                  date: '2023-03-10',
                  amount: 2280,
                  status: '已完成'
                },
                {
                  id: 'ORD20230220',
                  title: '高级双床房 - 1晚',
                  store: '秋果酒店·望京店',
                  date: '2023-02-20',
                  amount: 580,
                  status: '已完成'
                }
              ]}
              renderItem={order => (
                <List.Item>
                  <Card style={{ width: '100%', marginBottom: 12 }}>
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Text strong>{order.title}</Text>
                        <Text type="danger">¥{order.amount}</Text>
                      </div>
                      <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                          <div style={{ display: 'flex', alignItems: 'center', fontSize: 12, color: '#666' }}>
                            <ShopOutlined style={{ marginRight: 4 }} />
                            {order.store}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', fontSize: 12, color: '#666', marginTop: 4 }}>
                            <CalendarOutlined style={{ marginRight: 4 }} />
                            {order.date}
                          </div>
                        </div>
                        <div>
                          <Tag color={order.status === '已完成' ? 'green' : 'blue'}>
                            {order.status}
                          </Tag>
                        </div>
                      </div>
                      <Divider style={{ margin: '12px 0' }} />
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <Button size="small">再次预订</Button>
                        <Button size="small" type="primary">查看详情</Button>
                      </div>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          </div>
        );
      case 'rewards':
        return (
          <div style={{ padding: 16 }}>
            <Title level={4}>会员礼遇</Title>
            <div style={{ margin: '16px 0' }}>
              <Card 
                style={{ 
                  marginBottom: 16, 
                  borderRadius: 8,
                  background: 'linear-gradient(135deg, #4E6CA8 0%, #292E49 100%)',
                  color: '#fff'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar size={50} icon={<CrownOutlined />} style={{ backgroundColor: 'gold', color: '#fff' }} />
                  <div style={{ marginLeft: 16 }}>
                    <div style={{ fontSize: 18, fontWeight: 'bold' }}>{memberInfo.cardType}</div>
                    <div style={{ fontSize: 12, marginTop: 4 }}>尊享专属特权与优惠</div>
                  </div>
                </div>
                
                <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                  <Col span={8}>
                    <div style={{ textAlign: 'center' }}>
                      <WalletOutlined style={{ fontSize: 24 }} />
                      <div style={{ marginTop: 4, fontSize: 12 }}>余额支付</div>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ textAlign: 'center' }}>
                      <GiftOutlined style={{ fontSize: 24 }} />
                      <div style={{ marginTop: 4, fontSize: 12 }}>专属礼遇</div>
                    </div>
                  </Col>
                  <Col span={8}>
                    <div style={{ textAlign: 'center' }}>
                      <TeamOutlined style={{ fontSize: 24 }} />
                      <div style={{ marginTop: 4, fontSize: 12 }}>管家服务</div>
                    </div>
                  </Col>
                </Row>
                
                <Button type="primary" ghost style={{ marginTop: 16, width: '100%' }}>查看会员等级详情</Button>
              </Card>
              
              <Card style={{ marginBottom: 16 }}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Card bodyStyle={{ padding: 12 }}>
                      <Statistic
                        title="账户余额"
                        value={memberInfo.balance}
                        precision={0}
                        valueStyle={{ color: '#3f8600' }}
                        prefix="¥"
                      />
                      <Button size="small" style={{ marginTop: 8 }}>充值</Button>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card bodyStyle={{ padding: 12 }}>
                      <Statistic
                        title="会员积分"
                        value={memberInfo.points}
                        valueStyle={{ color: '#cf1322' }}
                      />
                      <Button size="small" style={{ marginTop: 8 }}>兑换</Button>
                    </Card>
                  </Col>
                </Row>
              </Card>
              
              <Title level={5}>尊享特权</Title>
              <List
                grid={{ column: 2, gutter: 16 }}
                dataSource={[
                  {
                    title: '入住优先升房',
                    icon: <ShopOutlined style={{ fontSize: 24, color: '#1890ff' }} />,
                    desc: '视酒店情况享受免费升级'
                  },
                  {
                    title: '积分加速',
                    icon: <GiftOutlined style={{ fontSize: 24, color: '#52c41a' }} />,
                    desc: '消费可获得2倍积分'
                  },
                  {
                    title: '专属管家',
                    icon: <TeamOutlined style={{ fontSize: 24, color: '#fa8c16' }} />,
                    desc: '一对一专属服务'
                  },
                  {
                    title: '延迟退房',
                    icon: <ClockCircleOutlined style={{ fontSize: 24, color: '#722ed1' }} />,
                    desc: '可延至14:00退房'
                  }
                ]}
                renderItem={item => (
                  <List.Item>
                    <Card bodyStyle={{ padding: 12 }}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ marginRight: 12 }}>
                          {item.icon}
                        </div>
                        <div>
                          <div style={{ fontWeight: 'bold' }}>{item.title}</div>
                          <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{item.desc}</div>
                        </div>
                      </div>
                    </Card>
                  </List.Item>
                )}
              />
              
              <Title level={5} style={{ marginTop: 16 }}>专享活动</Title>
              <Card
                style={{ marginBottom: 16, background: '#f6ffed', borderLeft: '4px solid #52c41a' }}
              >
                <div>
                  <div style={{ fontWeight: 'bold' }}>铂金会员专享SPA体验</div>
                  <div style={{ fontSize: 12, color: '#666', margin: '8px 0' }}>
                    入住即可享受60分钟精油SPA免费体验
                  </div>
                  <Tag color="green">限时优惠</Tag>
                  <Tag color="blue">活动进行中</Tag>
                </div>
              </Card>
              <Card
                style={{ marginBottom: 16, background: '#fff7e6', borderLeft: '4px solid #fa8c16' }}
              >
                <div>
                  <div style={{ fontWeight: 'bold' }}>会员专享餐饮88折</div>
                  <div style={{ fontSize: 12, color: '#666', margin: '8px 0' }}>
                    酒店内用餐享会员专属折扣
                  </div>
                  <Tag color="orange">长期有效</Tag>
                  <Tag color="blue">需出示会员卡</Tag>
                </div>
              </Card>
            </div>
          </div>
        );
      case 'profile':
        return (
          <div style={{ padding: 16 }}>
            <Title level={4}>会员中心</Title>
            <Card style={{ marginTop: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Avatar size={64} icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
                <div style={{ marginLeft: 16, flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text strong style={{ fontSize: 18 }}>{memberInfo.name}</Text>
                    <Button size="small" type="link">编辑资料</Button>
                  </div>
                  <div style={{ marginTop: 4 }}>
                    <Tag color="gold">
                      <CrownOutlined /> {memberInfo.cardType}
                    </Tag>
                  </div>
                  <div style={{ marginTop: 8, fontSize: 14, color: '#666' }}>
                    {memberInfo.phone}
                  </div>
                </div>
              </div>
              
              <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ textAlign: 'center', flex: 1 }}>
                  <div style={{ fontSize: 20, fontWeight: 'bold', color: '#529C8A' }}>{memberInfo.balance}</div>
                  <div style={{ fontSize: 12, color: '#666' }}>账户余额</div>
                </div>
                <Divider type="vertical" style={{ height: 40 }} />
                <div style={{ textAlign: 'center', flex: 1 }}>
                  <div style={{ fontSize: 20, fontWeight: 'bold', color: '#529C8A' }}>{memberInfo.points}</div>
                  <div style={{ fontSize: 12, color: '#666' }}>积分</div>
                </div>
                <Divider type="vertical" style={{ height: 40 }} />
                <div style={{ textAlign: 'center', flex: 1 }}>
                  <div style={{ fontSize: 20, fontWeight: 'bold', color: '#529C8A' }}>{memberInfo.coupons}</div>
                  <div style={{ fontSize: 12, color: '#666' }}>优惠券</div>
                </div>
              </div>
            </Card>

            <List style={{ marginTop: 16 }} bordered={false}>
              <Card style={{ marginBottom: 8 }}>
                <List.Item extra={<RightOutlined />} style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ShoppingOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                    <Text>我的订单</Text>
                  </div>
                </List.Item>
              </Card>
              <Card style={{ marginBottom: 8 }}>
                <List.Item extra={<RightOutlined />} style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <WalletOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                    <Text>钱包</Text>
                  </div>
                </List.Item>
              </Card>
              <Card style={{ marginBottom: 8 }}>
                <List.Item extra={<RightOutlined />} style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <GiftOutlined style={{ marginRight: 8, color: '#fa8c16' }} />
                    <Text>我的优惠券</Text>
                  </div>
                </List.Item>
              </Card>
              <Card style={{ marginBottom: 8 }}>
                <List.Item extra={<RightOutlined />} style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <TeamOutlined style={{ marginRight: 8, color: '#722ed1' }} />
                    <Text>我的管家</Text>
                  </div>
                </List.Item>
              </Card>
              <Card style={{ marginBottom: 8 }}>
                <List.Item extra={<RightOutlined />} style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <BellOutlined style={{ marginRight: 8, color: '#eb2f96' }} />
                    <Text>消息中心</Text>
                    {notificationCount > 0 && <Badge count={notificationCount} style={{ marginLeft: 8 }} />}
                  </div>
                </List.Item>
              </Card>
              <Card style={{ marginBottom: 8 }}>
                <List.Item extra={<RightOutlined />} style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CalendarOutlined style={{ marginRight: 8, color: '#13c2c2' }} />
                    <Text>客户反馈</Text>
                  </div>
                </List.Item>
              </Card>
            </List>
            
            <div style={{ marginTop: 32, textAlign: 'center' }}>
              <Button danger>退出登录</Button>
            </div>
          </div>
        );
      default:
        return renderHome();
    }
  };

  return (
    <Layout style={{ height: '100vh', width: '100%', maxWidth: 500, margin: '0 auto', background: '#f5f5f5' }}>
      <Header style={{ 
        background: '#fff', 
        padding: '0 16px', 
        height: 56, 
        lineHeight: '56px',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Title level={4} style={{ margin: 0 }}>秋果酒店·会员端</Title>
        <Space>
          <Badge count={notificationCount}>
            <BellOutlined style={{ fontSize: 18 }} />
          </Badge>
        </Space>
      </Header>
      <Content style={{ flex: 1, overflowY: 'auto' }}>
        {renderContent()}
      </Content>
      {renderFooter()}
    </Layout>
  );
};

export default MobileCustomerApp; 